import * as React from 'react';

function SvgLogo(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={232.594} height={39.012} {...props}>
      <defs>
        <style>
          {'.logo_svg__cls-1,.logo_svg__cls-2{fill:#fff}.logo_svg__cls-1{fill-rule:evenodd}'}
        </style>
      </defs>
      <g id="logo_svg__logo" transform="translate(-90.543 -145.804)">
        <g id="logo_svg__Group_424" data-name="Group 424" transform="translate(90.543 145.804)">
          <g id="logo_svg__Group_423" data-name="Group 423" transform="translate(52.757 2.198)">
            <path
              id="logo_svg__Path_813"
              d="M236.217 161.014v.267a.083.083 0 01-.053.088 3.372 3.372 0 01-1.935.405 3.443 3.443 0 01-3-2.136 3.4 3.4 0 01.121-3.056c.016-.034.033-.061.082-.061a5.643 5.643 0 012.521.546 3.766 3.766 0 011.981 2.268 5.865 5.865 0 01.283 1.679z"
              className="logo_svg__cls-1"
              data-name="Path 813"
              transform="translate(-230.924 -154.692)"
            />
            <path
              id="logo_svg__Path_814"
              d="M237.6 159.475c-.009-.155-.013-.307-.023-.455a5.341 5.341 0 00-.489-1.968 4.11 4.11 0 00-2.108-2.011 5.648 5.648 0 00-1.909-.465c-.135-.01-.269-.017-.421-.026.06-.076.1-.144.157-.2.138-.147.278-.294.421-.436a.159.159 0 01.1-.046 5.215 5.215 0 012.524.482 3.979 3.979 0 011.928 1.971 5.563 5.563 0 01.48 1.722c.03.227.047.458.067.686a.193.193 0 01-.037.115 3.232 3.232 0 01-.69.631z"
              className="logo_svg__cls-1"
              data-name="Path 814"
              transform="translate(-232.003 -153.03)"
            />
            <path
              id="logo_svg__Path_815"
              d="M235.538 152.17a3.541 3.541 0 014.88 4.832c-.014-.1-.023-.193-.033-.285a6.281 6.281 0 00-.473-1.81 4.381 4.381 0 00-2.946-2.524 5.734 5.734 0 00-1.372-.208l-.056-.005z"
              className="logo_svg__cls-1"
              data-name="Path 815"
              transform="translate(-233.804 -151.653)"
            />
          </g>
          <path
            id="logo_svg__Path_816"
            d="M143.51 162.321a113.6 113.6 0 00-3.544 1.166 158.234 158.234 0 00-10.485 3.923c-2.225.9-4.436 1.881-6.59 2.9q-1.8.832-3.565 1.7c-.59.3-1.186.6-1.776.905-2.654 1.354-5.2 2.807-7.643 4.246-2.962 1.817-5.775 3.635-8.317 5.517-.343.245-.687.5-1.017.75-.905.681-1.769 1.376-2.625 2.036-.962.828-1.93 1.579-2.814 2.379a16.273 16.273 0 01-3-6.632c.562-.407 1.13-.814 1.706-1.236 1.327-.885 2.667-1.818 4.1-2.7l.674-.421c2.646-1.65 5.5-3.222 8.485-4.774 2.59-1.291 5.263-2.576 8.036-3.762.7-.309 1.4-.61 2.12-.9a197.762 197.762 0 014.161-1.649 139.842 139.842 0 016.6-2.345 173.522 173.522 0 0114.584-4.161 5.194 5.194 0 00.91 3.058z"
            className="logo_svg__cls-2"
            data-name="Path 816"
            transform="translate(-91.533 -154.204)"
          />
          <path
            id="logo_svg__Path_817"
            d="M287.278 145.852c-.884-.016-2.194-.067-3.852-.041-1.663-.009-3.677.051-6 .129-1.156.058-2.38.126-3.679.2-1.3.1-2.663.2-4.09.313-2.839.281-5.916.6-9.164 1.079-2.326.324-4.733.728-7.2 1.183a5.542 5.542 0 01.407 2.132c0 .112-.01.217-.018.326a158.552 158.552 0 017.166-1.693c3.171-.7 6.189-1.233 8.983-1.709 1.4-.2 2.746-.407 4.02-.595q1.923-.241 3.646-.46c2.286-.237 4.293-.442 5.942-.544 1.656-.144 2.956-.186 3.841-.228s1.37-.069 1.37-.069-.48-.003-1.372-.023z"
            className="logo_svg__cls-2"
            data-name="Path 817"
            transform="translate(-192.129 -145.804)"
          />
          <path
            id="logo_svg__Path_818"
            d="M122.769 216.259c-.758 3.79-3.285 6.211-7.685 6.211a8.587 8.587 0 01-5.763-1.9c-.582.428-1.144.871-1.691 1.3-.345.273-.681.54-1.025.8-.414.351-.828.695-1.236 1.03-.526.436-1.032.85-1.495 1.264 2.6 2.394 6.2 3.72 10.808 3.72 8.689 0 14.247-4.5 14.907-12.429z"
            className="logo_svg__cls-2"
            data-name="Path 818"
            transform="translate(-98.865 -189.781)"
          />
          <path
            id="logo_svg__Path_819"
            d="M119.549 161.222a11.691 11.691 0 00-2.428-3.026c-2.576-2.126-5.958-3.137-10.155-3.137-10.864 0-16.423 6.674-16.423 17.742a27.389 27.389 0 00.2 3.467q.421-.294.842-.61l1.115-.752c1-.68 2.043-1.375 3.138-2.056a82.871 82.871 0 011.748-1.081c.281-6.352 3.186-10.493 9.377-10.493 2.772 0 4.814.87 6.085 2.589a98.328 98.328 0 012.407-1.017q2.13-.872 4.094-1.626z"
            className="logo_svg__cls-2"
            data-name="Path 819"
            transform="translate(-90.543 -151.581)"
          />
          <path
            id="logo_svg__Path_820"
            d="M181.3 189.787c.2-8.642 4.8-12.938 13.746-12.938H196v6.975h-2.274c-3.74 0-5.609 1.97-5.609 5.861v13.9H181.3z"
            className="logo_svg__cls-2"
            data-name="Path 820"
            transform="translate(-147.191 -165.182)"
          />
          <path
            id="logo_svg__Path_821"
            d="M234.927 176.849c2.173 0 3.234 1.061 3.234 3.235v23.5h-6.721v-26.735z"
            className="logo_svg__cls-2"
            data-name="Path 821"
            transform="translate(-178.49 -165.182)"
          />
          <path
            id="logo_svg__Path_822"
            d="M269.445 203.518c-8.086 0-12.23-4.65-12.431-13.847 0-9.147 4.093-13.746 12.33-13.9 6.469 0 10.31 2.881 11.473 8.691h-7.329a4.378 4.378 0 00-4.345-2.779c-3.538 0-5.306 2.678-5.306 7.985s1.87 7.985 5.609 7.935a5.247 5.247 0 004.043-1.92 3.1 3.1 0 012.274-.961h5.054c-1.217 5.46-5.155 8.948-11.372 8.796z"
            className="logo_svg__cls-2"
            data-name="Path 822"
            transform="translate(-194.453 -164.51)"
          />
        </g>
        <g id="logo_svg__Group_425" data-name="Group 425" transform="translate(179.675 148.705)">
          <path
            id="logo_svg__Path_823"
            d="M343.431 178.679h-8.692v12.23h-7.024v-30.677a3.646 3.646 0 013.537-3.688h11.674c7.278 0 11.068 3.891 11.068 11.067-.001 6.772-3.694 11.068-10.563 11.068zm-1.769-6.217c3.537.051 5.306-1.616 5.306-4.952s-1.667-5-4.951-5h-7.177v9.954z"
            className="logo_svg__cls-2"
            data-name="Path 823"
            transform="translate(-327.715 -155.409)"
          />
          <path
            id="logo_svg__Path_824"
            d="M400.365 189.787c.2-8.642 4.8-12.938 13.746-12.938h.96v6.975H412.8c-3.739 0-5.609 1.97-5.609 5.861v13.9h-6.822z"
            className="logo_svg__cls-2"
            data-name="Path 824"
            transform="translate(-373.062 -168.083)"
          />
          <path
            id="logo_svg__Path_825"
            d="M453.82 203.518c-8.086-.252-12.128-4.953-12.128-14.049s4.092-13.645 12.228-13.7c8.491 0 12.484 5.205 11.978 15.666h-17.285c.254 4.093 2.023 6.166 5.307 6.166a6.214 6.214 0 004.348-1.92 2.938 2.938 0 012.274-.961h4.953c-1.468 5.665-5.106 8.798-11.675 8.798zm-5.1-16.879h10.057c-.4-3.538-2.072-5.358-4.952-5.358s-4.604 1.819-5.11 5.358z"
            className="logo_svg__cls-2"
            data-name="Path 825"
            transform="translate(-398.858 -167.411)"
          />
          <path
            id="logo_svg__Path_826"
            d="M538.589 159.929v19.406c0 8.035-4.194 12.029-12.533 11.978-8.287-.153-12.433-4.65-12.433-13.545 0-9.1 3.538-13.746 10.663-14a8.421 8.421 0 017.632 4.144v-11.37h3.336a3.409 3.409 0 013.335 3.387zm-18.042 17.537c-.052 5.407 1.77 8.136 5.609 8.136s5.762-2.729 5.762-8.136c-.151-5.155-2.02-7.683-5.66-7.683s-5.508 2.528-5.711 7.683z"
            className="logo_svg__cls-2"
            data-name="Path 826"
            transform="translate(-443.757 -155.409)"
          />
          <path
            id="logo_svg__Path_827"
            d="M591.6 176.849c2.174 0 3.235 1.061 3.235 3.235v23.5h-6.721v-26.735z"
            className="logo_svg__cls-2"
            data-name="Path 827"
            transform="translate(-490.255 -168.083)"
          />
          <path
            id="logo_svg__Path_828"
            d="M624.242 203.518c-8.087 0-12.229-4.65-12.432-13.847 0-9.147 4.094-13.746 12.331-13.9 6.468 0 10.309 2.881 11.472 8.691h-7.328a4.378 4.378 0 00-4.345-2.779c-3.538 0-5.306 2.678-5.306 7.985s1.87 7.985 5.609 7.935a5.245 5.245 0 004.042-1.92 3.1 3.1 0 012.274-.961h5.054c-1.213 5.46-5.155 8.948-11.371 8.796z"
            className="logo_svg__cls-2"
            data-name="Path 828"
            transform="translate(-505.044 -167.411)"
          />
          <path
            id="logo_svg__Path_829"
            d="M688.244 168.976h-.708v14.808c0 1.111.658 1.718 1.972 1.718h2.071v5.1a36.851 36.851 0 01-7.074-.05c-2.527-.254-3.74-1.819-3.689-4.8v-29.208h3.484a3.39 3.39 0 013.233 3.385v4.245h4.043v1.465a3.269 3.269 0 01-3.332 3.337z"
            className="logo_svg__cls-2"
            data-name="Path 829"
            transform="translate(-548.116 -155.409)"
          />
          <path
            id="logo_svg__Path_830"
            d="M596.3 157.071a3.549 3.549 0 11-3.548-3.548 3.548 3.548 0 013.548 3.548z"
            className="logo_svg__cls-2"
            data-name="Path 830"
            transform="translate(-490.933 -153.523)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgLogo;
